document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.add-to-cart-float');
  const plusButtons = document.querySelectorAll('.qty-button.qty-plus');
  const minusButtons = document.querySelectorAll('.qty-button.qty-minus');

  function actualizarBotones(cart) {
    buttons.forEach(button => {
      const variantId = parseInt(button.dataset.variantId);
      const itemInCart = cart.items.find(i => i.variant_id === variantId);
      button.style.borderColor = itemInCart ? 'green' : '#ccc';
      button.dataset.inCart = itemInCart ? "true" : "false";
    });
  }

  function actualizarContadorCarrito() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const totalItems = cart.item_count;
        const bubbleWrapper = document.querySelector('#cart-icon-bubble');
        if (!bubbleWrapper) return;

        let bubble = bubbleWrapper.querySelector('.cart-count-bubble');

        if (totalItems > 0) {
          if (!bubble) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            bubbleWrapper.appendChild(bubble);
          }
          bubble.innerHTML = `<span aria-hidden="true">${totalItems}</span>`;
          bubble.style.display = 'block';
          bubble.classList.remove('bounce');
          void bubble.offsetWidth;
          bubble.classList.add('bounce');
        } else if (bubble) {
          bubble.remove();
        }
      });
  }

  function refrescarDrawerYMostrar() {
    fetch(`${window.location.pathname}?section_id=cart-drawer`)
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nuevoDrawer = doc.querySelector('cart-drawer');
        const actualDrawer = document.querySelector('cart-drawer');

        if (nuevoDrawer && actualDrawer) {
          actualDrawer.replaceWith(nuevoDrawer);

          const scripts = nuevoDrawer.querySelectorAll('script');
          scripts.forEach(oldScript => {
            const newScript = document.createElement('script');
            if (oldScript.src) {
              newScript.src = oldScript.src;
              newScript.defer = true;
            } else {
              newScript.innerHTML = oldScript.innerHTML;
            }
            document.body.appendChild(newScript);
          });

          setTimeout(() => {
            document.dispatchEvent(new CustomEvent('cart:updated'));
            if (typeof nuevoDrawer.open === 'function') {
              nuevoDrawer.open();
            } else {
              const fallback = document.querySelector('details.cart-drawer');
              if (fallback) fallback.setAttribute('open', 'true');
            }
          }, 50);
        }
      });
  }

  function handleAddToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({ id: variantId, quantity: 1 })
    })
    .then(() => {
      showToast("🛒 Producto agregado");
      actualizarContadorCarrito();
      refrescarDrawerYMostrar();
      document.dispatchEvent(new CustomEvent('cart:updated'));
    });
  }

  // Aplicar estilos y funcionalidad al botón de agregar al carrito
  buttons.forEach(button => {
    Object.assign(button.style, {
      backgroundColor: '#ffffff',
      color: '#111111',
      border: '1px solid #e0e0e0',
      borderRadius: '10px',
      padding: '10px',
      fontSize: '18px',
      cursor: 'pointer',
      transition: 'all 0.3s ease-in-out',
      transform: 'scale(1)',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
      marginRight: '13px'
    });

    button.addEventListener('mouseenter', () => {
      button.style.backgroundColor = '#01332a';
      button.style.transform = 'scale(1.05)';
      button.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
      button.style.borderColor = '#ccc';
    });

    button.addEventListener('mouseleave', () => {
      button.style.backgroundColor = '#ffffff';
      button.style.transform = 'scale(1)';
      button.style.boxShadow = '0 2px 6px rgba(0, 0, 0, 0.1)';
      button.style.borderColor = '#e0e0e0';
    });

    button.addEventListener('click', () => {
      const variantId = button.dataset.variantId;
      handleAddToCart(variantId);
    });
  });

  // Estilos modernos para los botones + y −
  [...plusButtons, ...minusButtons].forEach(btn => {
    Object.assign(btn.style, {
      backgroundColor: '#ffffff',
      color: '#111111',
      border: '1px solid #ddd',
      borderRadius: '6px',
      padding: '6px 10px',
      fontSize: '16px',
      cursor: 'pointer',
      transition: 'all 0.2s ease-in-out',
      transform: 'scale(1)',
      display: 'block'
    });

    btn.addEventListener('mouseenter', () => {
      btn.style.backgroundColor = '#f0f0f0';
      btn.style.transform = 'scale(1.1)';
    });

    btn.addEventListener('mouseleave', () => {
      btn.style.backgroundColor = '#ffffff';
      btn.style.transform = 'scale(1)';
    });
  });

  // Funcionalidad botón ➕
  plusButtons.forEach(plus => {
    plus.addEventListener('click', () => {
      const vid = plus.closest('.floating-cart-wrapper').dataset.variantId;
      handleAddToCart(vid);
    });
  });

  // Funcionalidad botón ➖
  minusButtons.forEach(minus => {
    minus.addEventListener('click', () => {
      const vid = parseInt(minus.closest('.floating-cart-wrapper').dataset.variantId);
      fetch('/cart.js').then(r => r.json()).then(cart => {
        const item = cart.items.find(i => i.variant_id === vid);
        if (item) {
          const qty = Math.max(item.quantity - 1, 0);
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: qty })
          })
          .then(() => {
            showToast(qty === 0 ? "❌ Eliminado" : "➖ Restado");
            actualizarContadorCarrito();
            refrescarDrawerYMostrar();
            document.dispatchEvent(new CustomEvent('cart:updated'));
          });
        }
      });
    });
  });

  function showToast(msg) {
    let toast = document.getElementById('toast-message');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'toast-message';
      Object.assign(toast.style, {
        position: 'fixed',
        bottom: '30px',
        right: '30px',
        background: '#fff',
        border: '1px solid #ccc',
        color: '#333',
        padding: '10px 16px',
        borderRadius: '8px',
        zIndex: '9999',
        boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
        fontWeight: '600',
        fontSize: '14px',
      });
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.style.display = 'block';
    setTimeout(() => { toast.style.display = 'none'; }, 2500);
  }

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => actualizarBotones(cart));

  document.addEventListener('cart:updated', () => {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => actualizarBotones(cart));
  });
});
